var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
/* tslint:disable: class-name */
/*
 * AUTOGENERATED FILE - DO NOT EDIT
 */
import { exContact } from './exContact';
import { exItem } from './exItem';
import { exPerson } from './exPerson';
import { exUser } from './exUser';
import { JSONStruct, array_property, nullable, property } from 'badphraim/data/JSONStruct';
export class exProjectRelation extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.id = 0;
        /** @override */ this.roles = [];
    }
}
__decorate([
    nullable,
    __metadata("design:type", exContact)
], exProjectRelation.prototype, "contact", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], exProjectRelation.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", exPerson)
], exProjectRelation.prototype, "person", void 0);
__decorate([
    array_property(exItem),
    __metadata("design:type", Array)
], exProjectRelation.prototype, "roles", void 0);
__decorate([
    nullable,
    __metadata("design:type", exUser)
], exProjectRelation.prototype, "user", void 0);
